exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhtml[data-v-1ff972aa] {\n  scroll-behavior: smooth;\n}\n.text-style[data-v-1ff972aa] {\n  color: #3bbcd4;\n}\n.sub-text-style[data-v-1ff972aa] {\n  text-shadow: -2px 2px 1px #ebebeb;\n  color: #00bcd4;\n  font-weight: 500;\n}\n.shiny-text[data-v-1ff972aa] {\n  text-shadow: -2px 2px 1px #3bbcd4;\n  color: #fff;\n  font-weight: 500;\n}\ndiv.example-snap[data-v-1ff972aa] {\n  padding: 15px;\n}\n@media (max-width: 991.98px) {\nspan.sub-text-style[data-v-1ff972aa] {\n    font-size: 1.5rem;\n}\n}\n@media (min-width: 992px) {\ndiv.example-snap[data-v-1ff972aa] {\n    padding: 0 100px 100px 100px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-1ff972aa","scoped":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/campaign/cleanStoryChallenge/index.vue
// module id = 2326
// module chunks = 0